<template>
  <el-timeline>
    <el-timeline-item
      v-for="(event, index) in events"
      :key="index"
      :timestamp="event.submitTime"
      v-if="events.length != 0"
      placement="top"
    >
      <el-card>
        <el-collapse v-model="activeNames" accordion>
          <el-collapse-item :name="index + 1">
            <template slot="title">
              <!-- 这里使用内联样式来简单地截断并显示省略号 -->
              <div style="max-width: 100%; line-height: 30px">
                {{ event.trueName + "\xa0\xa0\xa0\xa0\xa0\xa0" }}
                <el-tag
                  :type="
                    event.resultOption == '1'
                      ? 'info'
                      : event.resultOption == '2'
                      ? 'warning'
                      : ''
                  "
                  >{{ event.resultOption | StatusResultOption }}</el-tag
                >
                {{ "\xa0\xa0\xa0" + "服务概述：" + event.serveAbbr }}
              </div>
            </template>
            <span class="serveContent">服务内容:</span>
            <div class="content" v-html="event.serveContent"></div>
            <span class="serveContent">处理结果:</span>
            <div class="content">{{ event.handleResult }}</div>
            <div class="taskFileUrl">
              <p v-if="event.taskFileUrl">
                <span class="serveContent">附件:</span>
                {{ event.taskFileUrl.split("/").pop() }}
              </p>
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-download"
                v-if="event.taskFileUrl"
                :loading="show"
                @click="downloadFile(event.taskFileUrl)"
                >{{ show ? size : "任务附件" }}</el-button
              >
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
      <!-- {{ event.trueName }} <span> {{ event.serveAbbr }}</span> -->
    </el-timeline-item>
    <el-empty description="暂无数据" v-if="events.length == 0"></el-empty>
  </el-timeline>
</template>
   
  <script>
import { download } from "@/api/dict";
import { downloadFileByPost } from "@/utils/filenRequest.js";
import { mapState } from "vuex";
export default {
  name: "MyTimeline",
  props: {
    events: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeNames: 1,
      show: false,
      size: null,
    };
  },

  computed: {
    ...mapState({
      progress: (state) => state.progress,
    }),
  },
  watch: {
    progress: {
      handler(val) {
        this.size = val;
      },
      immediate: true,
    },
  },
  methods: {
    async downloadFile(url) {
      this.show = true;
      const res = await downloadFileByPost(url);
      if (res) {
        this.show = false;
        this.size = "下载中";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.icon_download {
  float: inline-end;
}
.serveContent {
  font-weight: 600;
  font-size: 14px;
  color: #409eff;
}
.content {
  // font-size: 14px;
  // margin-top: 10px;
  // margin-bottom: 10px;
  // line-height: 30px;
}
.taskFileUrl {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.content img {
  max-width: 100%;
}
.content {
  height: auto;
}
::v-deep .el-collapse-item__header {
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
  height: auto !important;
}
::v-deep .el-collapse {
  border: none;
}
</style>